import * as fromDatatype from '../datatype-library/index';

export interface bl_applet_label_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    guid_label_hdr: fromDatatype.GuidDataFieldInterface;
    header_table: fromDatatype.VarcharDatatypeInterface;
    line_table: fromDatatype.VarcharDatatypeInterface;
    guid_hdr: fromDatatype.GuidDataFieldInterface;
    guid_line: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
}


export class bl_applet_label_link_RowClass implements bl_applet_label_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    guid_label_hdr: fromDatatype.GuidDataFieldInterface;
    header_table: fromDatatype.VarcharDatatypeInterface;
    line_table: fromDatatype.VarcharDatatypeInterface;
    guid_hdr: fromDatatype.GuidDataFieldInterface;
    guid_line: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
}
